"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var GPUDevice_1 = require("engine/rendering/GPUDevice");
var Renderer_1 = require("engine/rendering/Renderer");
var SharedResources_1 = require("engine/SharedResources");
var Object2DInstances_1 = require("engine/ui/Object2DInstances");
var IntervalInstances = /** @class */ (function (_super) {
    __extends(IntervalInstances, _super);
    function IntervalInstances(instances) {
        var _this = _super.call(this, instances, [
            { name: 'position', type: GPUDevice_1.AttributeType.VEC2 }
        ], [
            { name: 'instanceAbsPosition', type: GPUDevice_1.AttributeType.VEC3 },
            { name: 'instanceRelPosition', type: GPUDevice_1.AttributeType.VEC2 },
            { name: 'instanceSize', type: GPUDevice_1.AttributeType.VEC4 },
            { name: 'instanceColor', type: GPUDevice_1.AttributeType.VEC4 },
        ], {
            'instanceAbsPosition': function (inst) { return [inst.x, inst.y, inst.z]; },
            'instanceRelPosition': function (inst) { return [inst.relativeX, inst.relativeY]; },
            'instanceSize': function (inst) { return [inst.w, inst.h, inst.relativeW, inst.relativeH]; },
            'instanceColor': function (inst) { return inst.color; },
        }) || this;
        _this.minWidth = 0;
        _this.additiveBlending = 0;
        _this.borderStrength = 0.3;
        _this.transparent = true;
        return _this;
    }
    IntervalInstances.prototype.draw = function (context) {
        context.uniform1f('minWidth', this.minWidth);
        context.uniform1f('blendFactor', 1.0 - this.additiveBlending);
        context.uniform1f('borderStrength', this.borderStrength);
        context.uniform2f('groupSize', this.computedWidth, this.computedHeight);
        context.uniform1f('groupOpacity', this.opacity);
        context.uniformMatrix4fv('groupModel', false, this.worldTransformMat4);
        context.extDrawInstanced(Renderer_1.DrawMode.TRIANGLES, 6, 0, this.instanceCount);
    };
    IntervalInstances.prototype.allocateGPUVertexState = function (device, attributeLayout, instanceVertexAttributes) {
        return device.createVertexState({
            indexBuffer: SharedResources_1.default.getQuadIndexBuffer(device),
            attributeLayout: attributeLayout,
            attributes: __assign({ 
                // vertices
                'position': {
                    buffer: SharedResources_1.default.getQuad1x1VertexBuffer(device),
                    offsetBytes: 0,
                    strideBytes: 2 * 4,
                } }, instanceVertexAttributes)
        });
    };
    IntervalInstances.prototype.getVertexCode = function () {
        return "\n            #version 100\n\n            precision highp float;\n\n            // for all instances\n            attribute vec2 position;\n            uniform float minWidth;\n            uniform mat4 groupModel;\n            uniform vec2 groupSize;\n\n            // per instance attributes\n            attribute vec3 instanceAbsPosition;\n            attribute vec2 instanceRelPosition;\n\n            attribute vec4 instanceSize;\n            attribute vec4 instanceColor;\n\n            varying vec2 vUv;\n\n            varying vec2 size;\n            varying vec4 color;\n\n            void main() {\n                vUv = position;\n\n                // yz are absolute domPx units, x is in fractions of groupSize\n                vec3 pos = vec3(\n                    instanceAbsPosition.xy + instanceRelPosition.xy * groupSize.xy,\n                    instanceAbsPosition.z\n                );\n\n                size = vec2(instanceSize.xy + instanceSize.zw * groupSize.xy);\n\n                // apply a minimum width\n                size.x = max(size.x, minWidth);\n\n                color = instanceColor;\n\n                gl_Position = groupModel * vec4(vec3(position * size, 0.0) + pos, 1.0);\n            }\n        ";
    };
    IntervalInstances.prototype.getFragmentCode = function () {
        return "\n            #version 100\n\n            precision highp float;\n\n            uniform float blendFactor;\n            uniform float borderStrength;\n            uniform float groupOpacity;\n\n            varying vec2 size;\n            varying vec4 color;\n\n            varying vec2 vUv;\n\n            void main() {\n                vec2 domPx = vUv * size;\n\n                const vec2 borderWidthPx = vec2(1.);\n\n                vec2 inner = step(borderWidthPx, domPx) * step(domPx, size - borderWidthPx);\n                \n                float border = 1.0 - inner.x * inner.y;\n\n                vec4 c = color;\n\n                c.rgb += border * vec3(borderStrength);\n                c.a = mix(c.a, c.a + borderStrength, border);\n\n                gl_FragColor = vec4(c.rgb, blendFactor) * c.a * groupOpacity;\n            }\n        ";
    };
    return IntervalInstances;
}(Object2DInstances_1.default));
exports.IntervalInstances = IntervalInstances;
exports.default = IntervalInstances;
